import Hero from './components/Hero'
import BandcampSection from './components/BandcampSection'
import AboutDrone from './components/AboutDrone'
import Footer from './components/Footer'

function App() {
  return (
    <div className="app">
      <div className="ambient-bg" />
      <main>
        <Hero />
        <BandcampSection />
        <AboutDrone />
      </main>
      <Footer />
    </div>
  )
}

export default App
